import PriceInput from './PriceInput';

export default PriceInput;
